"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const react_2 = require("react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const selectors_1 = require("src/redux/sagas/selectors");
const footer_1 = __importDefault(require("src/components/footer"));
const error_message_1 = __importDefault(require("src/components/error-message"));
const paginator_1 = __importDefault(require("src/components/paginator"));
const textDir_1 = __importDefault(require("src/hooks/textDir"));
const modal_1 = require("src/context/modal");
const size_1 = require("src/context/size");
const root_1 = require("src/utils/root");
const image_modal_1 = __importDefault(require("../image-modal"));
const common_1 = require("./common");
const app_video_styles_1 = __importDefault(require("./app-video.styles"));
const video_styles_1 = __importDefault(require("./themes/video/video.styles"));
const common_styles_1 = __importDefault(require("./common.styles"));
const markdown_styles_1 = __importDefault(require("./markdown.styles"));
const b = b_1.default.with('app');
const mediaQueryBreakpoints = {
    width: [180, 300, 400, 481, 500, 600, 601, 700],
    height: [240, 241, 360, 480, 481, 600, 601]
};
const useRootSize = () => {
    const root = (0, root_1.useRootService)().get();
    const [width, setWidth] = (0, react_2.useState)();
    const [height, setHeight] = (0, react_2.useState)();
    (0, react_2.useLayoutEffect)(() => {
        const observer = new resize_observer_polyfill_1.default(entries => {
            const [entry] = entries;
            const { width: w, height: h } = entry.contentRect;
            // избавляемся от бесконечного цикла, переносим операции, потенциально
            // модифицирующие размер блока в следующий рендер
            requestAnimationFrame(() => {
                setHeight(h);
                setWidth(w);
                root.style.setProperty('--vh', `${height}px`);
                root.style.setProperty('--vw', `${width}px`);
                // сбрасываем размер шрифта/отступы, только если контейнер увеличился
                // @ts-expect-error TS(2532): Object is possibly 'undefined'.
                if (w > width || h > height) {
                    root.style.fontSize = '100px';
                    root.style.setProperty('--rem', '100px');
                }
            });
        });
        observer.observe(root);
        return () => observer.disconnect();
    }, [root, width, height]);
    return (0, react_2.useMemo)(() => ({ width, height }), [width, height]);
};
// eslint-disable-next-line max-statements, complexity
const AppVideo = ({ children, ProgressBarComponent = () => { } }) => {
    const { showPagination = false, showFooter = true, showProgressBar = false, theme = 'default', background = null, errorMessage } = (0, react_redux_1.useSelector)((state) => {
        const { currentPage } = state.pages;
        const isFinishPage = currentPage === -1;
        const { background, displayMode, footer, pagination, progressBar, theme } = (0, selectors_1.getConfig)(state);
        const showPagination = pagination.enable && !isFinishPage;
        const showFooter = footer.enable;
        const showProgressBar = progressBar.enable;
        return {
            showPagination,
            showFooter,
            showProgressBar,
            theme,
            background,
            displayMode,
            errorMessage: (0, selectors_1.getFirstQuestionError)(state)
        };
    });
    const [minWidthMq, setMinWidthMq] = (0, react_2.useState)([]);
    const [maxWidthMq, setMaxWidthMq] = (0, react_2.useState)([]);
    const [minHeightMq, setMinHeightMq] = (0, react_2.useState)([]);
    const [maxHeightMq, setMaxHeightMq] = (0, react_2.useState)([]);
    const [showModal, setShowModal] = (0, react_2.useState)(false);
    const [url, setUrl] = (0, react_2.useState)(null);
    const size = useRootSize();
    const progressProps = (0, common_1.useProgressBarProps)();
    const style = background ? { '--theme-color': background, backgroundColor: background } : null;
    (0, textDir_1.default)();
    const classes = {
        theme,
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        orient: size.width >= size.height ? 'horiz' : 'vert'
    };
    (0, react_2.useEffect)(() => {
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        const minW = mediaQueryBreakpoints.width.filter(value => size.width >= value);
        setMinWidthMq(minW);
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        const maxW = mediaQueryBreakpoints.width.filter(value => size.width <= value);
        setMaxWidthMq(maxW);
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        const minH = mediaQueryBreakpoints.height.filter(value => size.height >= value);
        setMinHeightMq(minH);
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        const maxH = mediaQueryBreakpoints.height.filter(value => size.height <= value);
        setMaxHeightMq(maxH);
    }, [size.width, size.height]);
    const addMqClass = mqParamName => v => {
        classes[`${mqParamName}-${v}`] = 'yes';
    };
    minWidthMq.forEach(addMqClass('minWidth'));
    maxWidthMq.forEach(addMqClass('maxWidth'));
    minHeightMq.forEach(addMqClass('minHeight'));
    maxHeightMq.forEach(addMqClass('maxHeight'));
    const showImageModal = (imageUrl) => {
        setUrl(imageUrl);
        setShowModal(true);
    };
    const PaginatorComponent = paginator_1.default;
    return ((0, jsx_runtime_1.jsxs)(size_1.SizeProvider, Object.assign({ value: size }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b(classes), style: style }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: markdown_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: common_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: video_styles_1.default }), (0, jsx_runtime_1.jsx)(react_1.Global, { styles: app_video_styles_1.default }), showPagination && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('paginator') }, { children: (0, jsx_runtime_1.jsx)(PaginatorComponent, Object.assign({}, theme)) }))), (0, jsx_runtime_1.jsx)(modal_1.ModalProvider, Object.assign({ value: { showImageModal, theme } }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('body') }, { children: children })) })), showFooter && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('footer') }, { children: (0, jsx_runtime_1.jsx)(footer_1.default, {}) }))), showProgressBar && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('progress-bar') }, { children: (0, jsx_runtime_1.jsx)(ProgressBarComponent, Object.assign({}, progressProps)) }))), (0, jsx_runtime_1.jsx)(error_message_1.default, { message: errorMessage, size: 's' })] })), (0, jsx_runtime_1.jsx)(image_modal_1.default, { setShowModal: setShowModal, url: url, showModal: showModal })] })));
};
exports.default = AppVideo;
